<ion-card style="padding: 0;">
  <div class="overcard-title" *ngIf="page !== 5">
      {{title[this.titlePage]}}
  </div>

  <ion-row>

    <ion-col size="12" *ngIf="page == 0" class="goals-text">
      <ion-button (click)="nextpage(this.page)" style="width: 100%;padding-left: 20px;
    padding-right: 20px;
    margin-bottom: 20px;">Klik hier</ion-button>
    </ion-col>
    <ion-col size="1" *ngIf="page > 0" class="goals-text">
      <ion-button (click)="backpage(this.page)" style="width: 100%;color: #000;position: absolute;
    bottom: -1px; --background: transparent"><</ion-button>
    </ion-col>


    <ion-col *ngIf="page == 1" size="12" class="goals-text">
      <p>Als een van je hypotheken een besparing heeft kun je daarop drukken</p>
      <ion-item *ngFor="let mortgage of mortgageData.data; let i = index">
        <ion-label>
          {{mortgage.name}}
        </ion-label>
        <ion-note slot="end" *ngIf="mortgage.saving > 0" (click)="nextpage(this.page, i)">
          {{numberToCurrency(mortgage.saving)}} >
      </ion-note>
      <ion-note slot="end" *ngIf="mortgage.saving == 0">
        {{numberToCurrency(mortgage.saving)}}
    </ion-note>
      </ion-item>
      <br>
    </ion-col>

    <ion-col *ngIf="page == 2" size="12" class="goals-text">
      <hr>
      <h1>Je kunt besparen!</h1>
      <h2>{{ numberToCurrency( mortgageData.data[mortgageSelectIndex].saving ) }}/pm</h2>
      <hr>
      <h3>van:</h3>
      <h3>{{ mortgageData.data[mortgageSelectIndex].name }}</h3>
      <h2>{{ numberToCurrency(mortgageData.data[mortgageSelectIndex].cost) }}/pm</h2>
      <hr>
      <h3>naar:</h3>
      <ion-slides pager="true">
        <ion-slide  *ngFor="let alternative of alternativeMortgageData.data; let i = index">
          <div (click)="alternativenextpage(this.page, i)">
            <h3>{{ alternative.name }}</h3>
            <h2>{{ stringToCurrency(alternative.cost) }}/pm</h2>
          </div>
        </ion-slide>
        <br>
        <br>
      </ion-slides>
      <hr>
      <p>Swipe naar links of rechts om meerdere producten te zien en tik op de product naar keuze</p>
    </ion-col>

    <ion-col *ngIf="page == 3" size="12" class="goals-text">
      <ion-list>
        <hr>
        <h1 class="goals-text-title">Controleer je gegevens</h1>
         <h2 class="goals-text-stap">Stap 1/3</h2>
        <hr>
        <ion-item>
            <ion-label>Naam</ion-label>
            <ion-note slot="end">
                {{ person.first_name }} {{ person.middle_name }} {{ person.last_name }}
            </ion-note>
        </ion-item>

        <ion-item>
            <ion-label>Geslacht</ion-label>
            <ion-note slot="end">
                {{personGender}}
            </ion-note>
        </ion-item>

        <ion-item>
            <ion-label>Geboortedatum</ion-label>
            <ion-note slot="end">
                {{person.date_of_birth | date }}
            </ion-note>
        </ion-item>

        <ion-item>
            <ion-label>Telefoon nummer</ion-label>
            <ion-note slot="end">
                {{person.phone_number}}
            </ion-note>
        </ion-item>

        <ion-item>
            <ion-label>Mobiel nummer</ion-label>
            <ion-note slot="end">
                {{person.mobile_number}}
            </ion-note>
        </ion-item>

        <ion-item>
            <ion-label>Getrouwd</ion-label>
            <ion-note slot="end">
                {{person.marital_status.name}}
            </ion-note>
        </ion-item>

        <ion-item>
            <ion-label>Nationaliteit</ion-label>
            <ion-note slot="end">
                {{person.nationality?.name}}
            </ion-note>
        </ion-item>

        <ion-item>
            <ion-label>Relatie</ion-label>
            <ion-note slot="end">
                N/A
            </ion-note>
        </ion-item>

        <ion-item>
            <ion-label>BSN</ion-label>
            <ion-note slot="end">
                {{person.bsn}}
            </ion-note>
        </ion-item>
      </ion-list>

      <ion-button (click)="nextpage(this.page)" style="width: 100%;margin: 0;margin-top: 50px;--border-radius: none">Naar de volgende stap</ion-button>
    </ion-col>

    <ion-col *ngIf="page == 4" size="12" class="goals-text">
      <hr>
      <h1 class="goals-text-title">Huidige product</h1>
      <h2 class="goals-text-stap">Stap 2/3</h2>
      <hr>
      <ion-list>
        <ion-item>
          <ion-label>Naam</ion-label>
          <ion-note slot="end">
            {{ mortgageData.data[mortgageSelectIndex].name }}
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label>Prijs</ion-label>
          <ion-note slot="end">
            {{ stringToCurrency(mortgageData.data[mortgageSelectIndex].cost) }}
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label>Type</ion-label>
          <ion-note slot="end">
            {{ mortgageData.data[mortgageSelectIndex].mortgage_type.name }}
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label>Rente</ion-label>
          <ion-note slot="end">
            {{ mortgageData.data[mortgageSelectIndex].interest }}%
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label>Startdatum</ion-label>
          <ion-note slot="end">
            {{ dateRemoveTime(mortgageData.data[mortgageSelectIndex].start_date) }}
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label>Einddatum</ion-label>
          <ion-note slot="end">
            {{ dateRemoveTime(mortgageData.data[mortgageSelectIndex].end_date) }}
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label>Rente vaste periode</ion-label>
          <ion-note slot="end">
            {{ mortgageData.data[mortgageSelectIndex].interest_lock_period }} maanden
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label>Boetevrij aflossen</ion-label>
          <ion-note slot="end">
            {{ numberToCurrency(mortgageData.data[mortgageSelectIndex].debt_free_pay_off) }}
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label>NHG</ion-label>
          <ion-note slot="end">
            {{ nhgCheck(mortgageData.data[mortgageSelectIndex].nhg) }}
          </ion-note>
        </ion-item>
      </ion-list>

      <ion-button (click)="nextpage(this.page)" style="width: 100%;margin: 0;margin-top: 50px;--border-radius: none">Naar de volgende stap</ion-button>
    </ion-col>

    <ion-col *ngIf="page == 5" size="12" class="goals-text">
      <h1 class="goals-text-title">Overzicht</h1>
      <h2 class="goals-text-stap">Stap 3/3</h2>
      <hr>
      <ion-list>
        <ion-item>
          <ion-label>Huidige bedrijf</ion-label>
          <ion-note slot="end">
            {{ mortgageData.data[mortgageSelectIndex].name }}
          </ion-note>
        </ion-item>

        <ion-item>
          <ion-label>Nieuwe bedrijf</ion-label>
          <ion-note slot="end">
            {{ alternativeMortgageData.data[index].name }}
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label>Prijs</ion-label>
          <ion-note slot="end">
            {{ stringToCurrency(alternativeMortgageData.data[index].cost) }}
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label>Type</ion-label>
          <ion-note slot="end">
            {{ mortgageData.data[0].mortgage_type.name }}
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label>Rente</ion-label>
          <ion-note slot="end">
            {{ alternativeMortgageData.data[index].interest }}%
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label>Rente vaste periode</ion-label>
          <ion-note slot="end">
            {{ alternativeMortgageData.data[index].interest_lock_period }} maanden
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label>Boetevrij aflossen</ion-label>
          <ion-note slot="end">
            {{ stringToCurrency(alternativeMortgageData.data[index].penalty) }}
          </ion-note>
        </ion-item>
      </ion-list>

      <ion-button (click)="nextpage(this.page)" style="width: 100%;margin: 0;margin-top: 50px;--border-radius: none">Aanvraag sturen</ion-button>
    </ion-col>

    <ion-col *ngIf="page == 6" size="12" class="goals-text">
      <div>
        <ion-icon name="checkmark-circle-outline" style="font-size: 150px;margin-top: 45px;margin-bottom: 75px; color: yellowgreen"></ion-icon>
      </div>
      <h1 class="complete">Aanvraag compleet</h1>
      <h3 class="medewerker">Onze medewerker<br>neemt contact met jou op</h3>
      <h4 class="geniet">Geniet van je dag</h4>

      <ion-button (click)="nextpage(0)" style="width: 100%;margin: 0;margin-top: 50px;--border-radius: none">Tik hier om terug naar start te gaan</ion-button>
    </ion-col>
  </ion-row>
</ion-card>
